<template>
    <el-card class="cross-doubt-wrap mh">
        <p class="ft28 mb10">窜货可疑列表</p>
        <p class="tips ft13 mb10">提示：当溯源码出库时销往的省市区与溯源码被查询真伪时的省市区不同，则系统判定为疑似窜货</p>
        <el-form size="mini" inline>
            <el-form-item>
                <el-input placeholder="溯源码" v-model="selects.traceable_code" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-input placeholder="防伪码" v-model="selects.security_code" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-select v-model="selects.platform_id" placeholder="全部平台" clearable>
                    <el-option
                        v-for="item in platformList"
                        :key="item.key"
                        :label="item.value"
                        :value="item.key">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getSelects">筛选</el-button>
                <el-button @click="exportExcel" :disabled="!exportData.hasOver">导出</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="dataList" header-row-class-name="table-black-header">
            <el-table-column label="溯源码" prop="traceable_code"></el-table-column>
            <el-table-column label="防伪码" prop="security_code"></el-table-column>
            <el-table-column label="所属平台" prop="platform_name"></el-table-column>
            <el-table-column label="商品名称" prop="goods_name"></el-table-column>
            <el-table-column label="出库绑定商品时间" prop="activated_at"></el-table-column>
            <el-table-column label="被查询真伪时间" prop="createtime"></el-table-column>
            <el-table-column label="出库收货人地址">
                <template slot-scope="scope">
                    {{ scope.row.receiver_province }}{{ scope.row.receiver_city }}{{ scope.row.receiver_area }}
                </template>
            </el-table-column>
            <el-table-column label="查询人所在地址">
                <template slot-scope="scope">
                    {{ scope.row.query_province }}{{ scope.row.query_city }}{{ scope.row.query_area }}
                </template>
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="text" @click="toDetail(scope.row.traceable_code)">查看详情</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!--页码信息-->
        <div class="ftc mt10">
            <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                :total="page.total"
                :page-size="page.per_page"
                @current-change="currentPageChange"
            ></el-pagination>
        </div>
    </el-card>
</template>

<script>
    import XLSX from 'xlsx'
    import {stickerApi} from "@/api/sticker"
    export default {
        data() {
            return {
                selects: {
                    traceable_code: '',
                    security_code: '',
                    platform_id: '',
                },
                platformList: [],
                dataList: [],
                page: {
                    current_page: 1,
                    per_page: 20,
                    total: 0
                },
                // 导出
                exportData: {
                    current_page: 1,
					totalPages: 1,
					per_page: 50,
					exportList: [],
					isGetting: false, //是否正在请求中
					hasOver: true, //是否请求完毕
					messageBox: ''
                },
            }
        },
        created() {
            this.getPlatformPermission()
            this.getSelects()
        },
        methods: {
            // 获取有权限的平台列表
            getPlatformPermission() {
                this.$EpetJs.Common.ajax('get', stickerApi.getPlatformPermissionUrl).then(res => {
                    if(res) {
                        this.platformList = res.data.data || []
                    }
                })
            },
            // 获取列表
            getList() {
                const pam = {
                    ...this.selects,
                    page: this.page.current_page,
                    per_page: this.page.per_page
                }
                this.$EpetJs.Common.ajax('get', stickerApi.getCrossDoubtListUrl, pam, {
                    needLoading: true
                }).then(res => {
                    if(res) {
                        this.dataList = res.data.data || []
                        if (res.data.meta && res.data.meta.pagination) {
                            this.page.total = res.data.meta.pagination.total
                        }
                    }
                })
            },
            toDetail(id) {
                this.$router.push("/sticker/detail/" + id)
            },
            // 开始导出
            exportExcel() {
                this.exportData.exportList = [];
				this.exportData.current_page = 1;
				this.exportData.totalPages = 1;
				this.exportData.isGetting = false;
				this.exportData.hasOver = false;
				this.exportData.messageBox = this.$message({
					duration: 0,
					showClose: true,
					message: '正在导出',
				})
                this.getExportList()
            },
            // 获取导出列表
            getExportList() {
                if (this.exportData.isGetting) {
					return false
				}
                const pam = {
                    ...this.selects,
                    page: this.exportData.current_page,
                    per_page: this.exportData.per_page
                }
                this.$EpetJs.Common.ajax('get',stickerApi.getCrossDoubtListUrl,pam).then(res => {
					if(res) {
						this.exportData.isGetting = false
						this.exportData.exportList = this.exportData.exportList.concat(res.data.data || [])
						if (this.exportData.exportList.length == 0) {
                            this.exportData.hasOver = true
							this.exportData.messageBox.close()
							this.$message.warning('没有数据可以导出！')
							return false
						}
						if (res.data.meta.pagination.current_page == res.data.meta.pagination.total_pages) {
							this.exportData.hasOver = true
							this.exportData.messageBox.close()
							this.$message.success('导出成功！')
							this.confirmExport()
						} else {
							this.exportData.current_page++;
							this.exportData.messageBox.message = '正在导出:' + this.exportData.current_page + '/' + res.data.meta.pagination.total_pages
							this.getExportList()
						}
					}else{
						this.exportData.hasOver = true
						this.$EpetJs.Common.confirm('导出失败，是否重新开始导出', '操作确认', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(_ => {
							this.exportData.messageBox.close()
							this.exportExcel()
						}).catch(_ => {
							this.exportData.messageBox.close()
						})
					}
				})
            },
            //确认导出
			confirmExport() {
                let tempList = this.exportData.exportList.map(v => {
                    return {
                        '溯源码': v.traceable_code,
                        '防伪码': v.security_code,
                        '所属平台':v.platform_name,
                        '商品名称': v.goods_name,
                        '出库绑定商品时间': v.activated_at,
                        '被查询真伪时间': v.createtime,
                        '出库收货人地址': `${v.receiver_province||''}${v.receiver_city||''}${v.receiver_area||''}`,
                        '查询人所在地址': `${v.query_province||''}${v.query_city||''}${v.query_area||''}`
                    }
				})
				let ws = XLSX.utils.json_to_sheet(tempList)
				let wb = XLSX.utils.book_new()
				var name = '窜货可疑列表导出_' + JSON.stringify(new Date().getFullYear()) + JSON.stringify(new Date().getMonth() + 1) + JSON.stringify(
					new Date().getDate()) + Math.floor(Math.random() * (9999 - 1000)) + '.xlsx';
				XLSX.utils.book_append_sheet(wb, ws, "窜货可疑列表导出")
				XLSX.writeFile(wb, name)
            },
            // 筛选
            getSelects() {
                this.page.current_page = 1
                this.getList()
            },
            // 当前页更改
            currentPageChange(val) {
                this.page.current_page = val
                this.getList()
            }
        }
    }
</script>

<style lang="less" scoped>
    .cross-doubt-wrap {
        .tips {
            color: #FB7513;
        }
    }
</style>